import Page from "@app/components/pageTypes/Page/Page"

import { MyParadiseThermencardModal } from "@app/modals/MyParadise/MyParadiseThermencardModal/MyParadiseThermenCardModal"
import "./styles.css"

export default function AppThermencardPage() {
	return (
		<Page className="appdataPage">
			<MyParadiseThermencardModal />
		</Page>
	)
}
